import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8jehdemzqt: FaireBrandEntity = {
  token: "b_8jehdemzqt",
  type: "brand",
  name: "Vive La Fete",
  avatarUrl:
    "https://cdn.faire.com/fastly/22b5d113ea533faebb2c0325e36458c4862f86983727ff07563528f6875da37b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/acdf1e0e3c52d4970c6eb97af25d8df314896397ad65fc37d893b2660891fd13.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/22b5d113ea533faebb2c0325e36458c4862f86983727ff07563528f6875da37b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/acdf1e0e3c52d4970c6eb97af25d8df314896397ad65fc37d893b2660891fd13.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 250,
  rating: 4.3,
  reviewCount: 62,
  isTopShop: true,
  isInsider: true,
  description:
    "Vive La Fete is dedicated to quality and excellence, offering unique, high-quality products for children with exceptional designs and outstanding service to our customers.\n\nVive La Fete, Inc, offers styles that customers look for from traditional hand smocking to our fun appliqués and embroidered garments, always using the most beautiful fabrics. Our catalog features officially licensed apparel for more than 350 teams around USA and most recently a few of the beat Soccer Team Football Clubs. \n\nOur products are made to order with exceptional quality",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:57.929Z",
    importedBy: "entity-db-cli",
  },
};
